import {ChevronDownIcon, ChevronRightIcon} from "@heroicons/react/24/outline";
import {genericMoneyFormatter} from "../../../../common/util/util-vanilla";
import React, {useEffect, useState} from "react";

export default function StatementListItem({
                                              name,
                                              statement,
                                              isSectionCollapsed,
                                              onToggleSectionClick,
                                              zeroValuesShown,
                                              expandedAllCount,
                                              collapsedAllCount,
                                              handleToggleAccountDetails
                                          }) {
    if (!statement[name]) {
        return null;
    }

    const totals = (statement[name] ?? []).reduce((memo, it) => {
        memo += it.Value;
        return memo;
    }, 0);

    return <div>

        <button
            onClick={onToggleSectionClick}
            className={'w-full pl-3 hover:bg-tm-gray-100 space-x-3 whitespace-nowrap py-4 pr-3 text-sm font-medium text-tm-gray-900 flex justify-start items-center cursor-pointer'}
        >
            {!isSectionCollapsed ?
                (<ChevronDownIcon
                    className={`size-4`}/>)
                :
                (<ChevronRightIcon
                    className={`size-4`}/>)
            }

            <span className="text-lg leading-6 font-medium text-tm-gray-900">{name}</span>
        </button>

        {!isSectionCollapsed && statement[name] && (
            <StatementListItemChildren
                items={statement[name]}
                handleToggleAccountDetails={handleToggleAccountDetails}
                zeroValuesShown={zeroValuesShown}
                expandedAllCount={expandedAllCount}
                collapsedAllCount={collapsedAllCount}
            />
        )}

        <div
            className="border-y border-tm-gray-200 py-2 mt-3 flex text-base items-center justify-between mb-4 pl-4 pr-2 font-bold">
            <div>Total {name}</div>
            <div>{genericMoneyFormatter(Math.abs(totals))}</div>
        </div>
    </div>
}

function StatementListItemChildren({
                                       items,
                                       zeroValuesShown,
                                       expandedAllCount,
                                       collapsedAllCount,
                                       handleToggleAccountDetails
                                   }) {
    let parentItems = [];

    const itemsChildren = items.reduce((memo, it) => {
        if (it.ParentAccountID) {
            if (!memo[it.ParentAccountID]) {
                memo[it.ParentAccountID] = [];
            }

            memo[it.ParentAccountID].push(it);
        } else {
            parentItems.push(it);
        }
        return memo;
    }, {});

    const [collapsed, setCollapsed] = useState({});

    function handleToggleCollapseClick(accountName) {
        const collapsedUpdate = Object.assign({}, collapsed);
        if (collapsedUpdate[accountName]) {
            delete collapsedUpdate[accountName];
        } else {
            collapsedUpdate[accountName] = accountName;
        }

        setCollapsed(collapsedUpdate);
    }

    useEffect(() => {
        if (expandedAllCount) {
            setCollapsed({});
        }
    }, [expandedAllCount]);

    useEffect(() => {
        if (collapsedAllCount) {
            setCollapsed(items.reduce((memo, it) => {
                memo[it.AccountName] = it.AccountName;
                return memo;
            }, {}));
        }
    }, [collapsedAllCount]);

    return <div className="ml-4">
        {parentItems.map((item) => {
            const hasChildren = !!itemsChildren[item.AccountID];
            const childrenTotalValues = itemsChildren[item.AccountID]?.reduce((memo, it) => {
                return memo + parseFloat(it.Value);
            }, 0);
            const isSectionCollapsed = !!collapsed[item.AccountName];
            const displayedValue = isSectionCollapsed
                ? item.Value + childrenTotalValues
                : item.Value;

            if (!hasChildren && zeroValuesShown && displayedValue === 0) {
                return null;
            }

            return <div key={item.AccountName}>
                <div className="flex justify-start items-center">
                    <div className="relative size-10 flex items-center justify-center">
                        {hasChildren && (
                            <button
                                className="flex items-center justify-center btn-icon"
                                onClick={() => handleToggleCollapseClick(item.AccountName)}
                            >
                                {!isSectionCollapsed ?
                                    (<ChevronDownIcon
                                        className={`size-4`}/>)
                                    :
                                    (<ChevronRightIcon
                                        className={`size-4`}/>)
                                }
                            </button>
                        )}
                    </div>

                    <button
                        className="w-full hover:bg-tm-gray-100 py-2 pr-2 text-lg leading-6 font-medium text-tm-gray-500 flex justify-start items-center cursor-pointer"
                        onClick={() => handleToggleAccountDetails(item)}
                    >
                        <div
                            className={"ml-3 w-full flex items-center grid grid-cols-2"}
                        >
                            <div
                                className="flex items-center gap-4 relative"
                            >
                                {item.AccountName}
                            </div>

                            <div
                                className={"text-right"}>{genericMoneyFormatter(displayedValue)}</div>
                        </div>
                    </button>
                </div>

                {hasChildren && !isSectionCollapsed && itemsChildren[item.AccountID].map((child) => {
                    if (zeroValuesShown && !child.Value) {
                        return null;
                    }

                    return <buttpm
                        onClick={() => handleToggleAccountDetails(child)}
                        key={child.AccountName}
                        className="hover:bg-tm-gray-300 py-2 pr-2 text-lg leading-6 font-medium text-tm-gray-500 flex justify-start items-center cursor-pointer"
                    >
                        <div
                            className="ml-3 w-full flex items-center grid grid-cols-2"
                        >
                            <span
                                className='pl-16'>{child.AccountName}</span><span className="text-right">{genericMoneyFormatter(child.Value ?? 0)}</span>
                        </div>
                    </buttpm>
                })
                }
            </div>
        })}
    </div>
}